/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/

import React, { useState } from 'react';
import {
	// MenuItem,
	TextField
} from '@mui/material';
import { FormattedMessage, injectIntl } from 'react-intl';
import SettingsPaper from '../utils/SettingsPaper';
import { rename, updateDescription } from './AppGraphQL';
import { useLocalState } from './GraphQLWSClient';

function AppSettingsAppsComponent({ app, open, onClose, intl }) {
	const [name, setName, , isNameChanged] = useLocalState(app.name);
	console.log('AppSettingsApps', `app.name`, app.name);
	const [description, setDescription, , isDescriptionChanged] = useLocalState(app.settings.description);
	const [nameError, setNameError] = useState();

	const validateName = (newName) => {
		if (!newName) {
			setNameError(
				intl.formatMessage({
					id: 'Error.EmptyName',
					defaultMessage: ''
				})
			);
			return false;
		}
		setNameError(undefined);
		return true;
	};

	const onNameChange = (event) => {
		setName(event.target.value);
		validateName(event.target.value);
	};

	const onNameBlur = async () => {
		if (isNameChanged && validateName(name)) {
			const result = await rename(app.id, name);
			if (result === 'CONFLICT') {
				setNameError(
					intl.formatMessage({
						id: 'Error.DuplicateName',
						defaultMessage: ''
					})
				);
			}
		}
	};

	const onDescriptionChange = (event) => setDescription(event.target.value);

	const onDescriptionBlur = () => {
		if (isDescriptionChanged) {
			updateDescription(app.id, description);
		}
	};

	// const handleWorkSpaceChange = (/* ws */) => {};

	if (!open) {
		return null;
	}

	return (
		<SettingsPaper
			open={open}
			close={onClose}
			helpContext="appsettings"
			title={<FormattedMessage id="AppSettings.Title" defaultMessage="App Settings" />}
		>
			<TextField
				variant="outlined"
				size="small"
				margin="normal"
				label={<FormattedMessage id="AppSettings.AppName" defaultMessage="App Name" />}
				fullWidth
				value={name}
				onKeyUp={async (e) => {
					if (e.key === 'Escape') {
						setName(null);
					} else if (e.key === 'Enter') {
						onNameBlur();
						e.target.blur();
					}
				}}
				error={typeof nameError === 'string'}
				helperText={nameError}
				onChange={(event) => onNameChange(event)}
				onBlur={(event) => onNameBlur(event)}
			/>
			<TextField
				variant="outlined"
				size="small"
				margin="normal"
				label={<FormattedMessage id="AppSettings.AppDescription" defaultMessage="App Description" />}
				fullWidth
				multiline
				value={description}
				onKeyUp={async (e) => {
					if (e.key === 'Escape') {
						setDescription(null);
					} else if (e.key === 'Enter' && e.ctrlKey) {
						onDescriptionBlur();
						e.target.blur();
					}
				}}
				onChange={(event) => onDescriptionChange(event)}
				onBlur={(event) => onDescriptionBlur(event)}
			/>
			{/* <TextField
				variant="outlined"
				size="small"
				margin="normal"
				select
				fullWidth
				value={app.scope.id}
				onChange={(event) => handleWorkSpaceChange(event.target.value)}
				label={<FormattedMessage id="AppSettings.Workspace" defaultMessage="Workspace" />}
			>
				{Object.entries(props.scopeNames).map(([key, nam]) => (
					<MenuItem value={key} key={key}>
						{nam}
					</MenuItem>
				))}
			</TextField> */}
		</SettingsPaper>
	);
}

export const AppSettingsApps = injectIntl(AppSettingsAppsComponent);
